<template>
  
  <div class="tabs-container ng-scope" style="padding-bottom:50px;margin-top:18px;">
    <div id="wrapperp">
      <ul class="nav nav-tabs">
        <li
          class="tabLi"
          v-for="(data,$index) in langData"
          :key="$index"
          :class="{'active':$index==0}"
        >
          <div class="tabDiv" @click="changeTab($index)"></div>
          <a
            :class="true?'tab'+$index:''"
            data-toggle="tab"
            :href="true?'#tab-'+$index:''"
            aria-expanded="true"
            @click="showTab($event,$index)"
          >{{ $t("message." + data) }}</a>
        </li>
      </ul>
    </div>
    <form method="get" class="form-horizontal" id="baseInfo" novalidate="novalidate">
      <div class="tab-content">
        <div
          :id="'tab-'+index"
          v-for="(langItem, index) in articleDetail.langMap"
          :key="index"
          class="tab-pane"
        >
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.issueName") }}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <select class="form-control"  :name="'Issue'+langLabel(langItem.langCode)" v-validate="'required'" v-model="articleDetail.magazineId">
                      <option  value="">{{$t("message.PleaseSelect") }}</option>
                      <option  class="ng-binding" v-for="issue in issueList" v-bind:value="issue.id">{{issue['title'+langItem.langCode]}}</option>
                    </select>
                  </div>
                  <label class="error">{{ errors.first('Issue'+langLabel(langItem.langCode)) }}</label>
                </div>
              </div>
              <!--<div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.Category") }}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <select class="form-control"  :name="'Category'+langLabel(langItem.langCode)" v-validate="'required'" v-model="articleDetail.categoryId">
                      <option  value="">{{$t("message.PleaseSelect") }}</option>
                      <option  class="ng-binding" v-for="category in categoryList" v-bind:value="category.id">{{category['name'+langItem.langCode]}}</option>
                    </select>
                  </div>
                  <label class="error">{{ errors.first('Category'+langLabel(langItem.langCode)) }}</label>
                </div>
              </div>-->
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.subCategory") }}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <select class="form-control"  :name="'subCategory'+langLabel(langItem.langCode)" v-validate="'required'" v-model="articleDetail.subCategoryIds">
                      <option  value="">{{$t("message.PleaseSelect") }}</option>
                      <option  class="ng-binding" v-for="category in subCategoryList" v-bind:value="category.id">{{category['name'+langItem.langCode]}}</option>
                    </select>
                  </div>
                  <label class="error">{{ errors.first('subCategory'+langLabel(langItem.langCode)) }}</label>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.Author/Interviewee name") }}
                </label>
                <div class="col-sm-10">
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="langItem.authorName"
                      data-vv-validate-on="blur"
                      :name="'authorName - '+langLabel(langItem.langCode)"
                      :maxlength="langItem.langCode=='en_US'?60:30"
                    />
                  </div>
                  <label class="error">{{ errors.first('authorName - '+langLabel(langItem.langCode)) }}</label>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.Author/Interviewee title") }}
                </label>
                <div class="col-sm-10">
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="langItem.authorTitle"
                      data-vv-validate-on="blur"
                      :name="'authorTitle - '+langLabel(langItem.langCode)"
                      :maxlength="langItem.langCode=='en_US'?60:30"
                    />
                  </div>
                  <label class="error">{{ errors.first('authorTitle - '+langLabel(langItem.langCode)) }}</label>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.Author/Interviewee icon") }}
                </label>
                <div class="col-sm-10">
                  <div class="deleteImage" v-if="langItem.authorIcon" @click="langItem.authorIcon = ''">
                    <i class="fa fa-close"></i>
                  </div>
                  <file-upload
                    :fileUploadUrl="fileUploadUrl"
                    :filewidth="300"
                    :fileheight="300"
                    :limit="5"
                    v-model="langItem.authorIcon"
                    :name="'Interviewee icon - '+langLabel(langItem.langCode)"
                    @click="validateIt('Interviewee icon - '+langLabel(langItem.langCode))"
                  >
                    <template v-slot:sizeError>
                      <div style="color:red">Size error!</div>
                    </template>
                    <template v-slot:dimensionError>
                      <div style="color:red">Dimension Error!</div>
                    </template>
                    <template v-slot:sizeHint>300 x 300, Max 5 MB.</template>
                  </file-upload>
                  <label
                    class="error"
                  >{{ errors.first('Interviewee icon - '+langLabel(langItem.langCode)) }}</label>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.Short description") }}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <textarea
                      type="text"
                      class="form-control"
                      v-model.trim="langItem.shortDescription"
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :name="'shortDescription - '+langLabel(langItem.langCode)"
                      style="min-height:100px;"
                      :maxlength="langItem.langCode=='en_US'?500:300"
                    />
                  </div>
                  <label class="error">{{ errors.first('shortDescription - '+langLabel(langItem.langCode)) }}</label>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.Article title") }}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="langItem.title"
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :name="'title - '+langLabel(langItem.langCode)"
                      :maxlength="langItem.langCode=='en_US'?150:30"
                    />
                  </div>
                  <label class="error">{{ errors.first('title - '+langLabel(langItem.langCode)) }}</label>
                </div>
              </div>
              <!--div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.Facebook article ID") }}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="langItem.facebookArticleId"
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :name="'facebookArticleId - '+langLabel(langItem.langCode)"
                    />
                  </div>
                  <label class="error">{{ errors.first('facebookArticleId - '+langLabel(langItem.langCode)) }}</label>
                </div>
              </div-->
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.Cover image") }}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <file-upload
                    :fileUploadUrl="fileUploadUrl"
                    :filewidth="1320"
                    :fileheight="690"
                    :limit="5"
                    v-model="langItem.coverPhoto"
                    :name="'Cover Photo - '+langLabel(langItem.langCode)"
                    @click="validateIt('Cover Photo - '+langLabel(langItem.langCode))"
                    v-validate="'required'"
                  >
                    <template v-slot:sizeError>
                      <div style="color:red">Size error!</div>
                    </template>
                    <template v-slot:dimensionError>
                      <div style="color:red">Dimension Error!</div>
                    </template>
                    <template v-slot:sizeHint>1320 x 690, Max 5 MB.</template>
                  </file-upload>
                  <label
                    class="error"
                  >{{ errors.first('Cover Photo - '+langLabel(langItem.langCode)) }}</label>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.Cover image alt text") }}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="langItem.coverPhotoCaption"
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :name="'coverPhotoCaption - '+langLabel(langItem.langCode)"
                      :maxlength="langItem.langCode=='en_US'?100:50"
                    />
                  </div>
                  <label class="error">{{ errors.first('coverPhotoCaption - '+langLabel(langItem.langCode)) }}</label>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.Content editor") }}
                </label>
                <div class="col-sm-10">
                  <ckeditor :editor="editor" v-model="langItem.content" :config="editorConfig" ></ckeditor>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.Slideshow") }}
                </label>
                <div class="col-sm-5">
                  <file-upload
                    :fileUploadUrl="fileUploadUrl"
                    :filewidth="1320"
                    :fileheight="690"
                    :limit="5"
                    v-model="addImage"
                    :name="'addImage - '+langLabel(langItem.langCode)"
                    :callback="addSlideShowImage"
                    :item = "langItem"
                  >
                    <template v-slot:sizeError>
                      <div style="color:red">Size error!</div>
                    </template>
                    <template v-slot:dimensionError>
                      <div style="color:red">Dimension Error!</div>
                    </template>
                    <template v-slot:sizeHint>1320 x 690, Max 5 MB.</template>
                  </file-upload>
                  <draggable 
                    class="sortable-list connectList0 agile-list"
                    style="max-height: 900px;overflow: auto;margin-bottom: 15px;"
                    v-model="langItem.imageCaption" 
                    group="people" 
                    @start="drag=true" 
                    @end="drag=false"
                    >
                     <div v-for="(task,index) in langItem.imageCaption" class="dragObj">
                        <div style="padding: 5px">
                           <input type="text" style="width:100%;" v-model="task.caption"></input>
                        </div>
                        <a class="pull-right btn btn-xs btn-white" style="position: absolute;top: 10px;right: 10px;" @click="deleteCaption(index,langItem.imageCaption)">{{$t("message.Delete") }}</a>
                     </div>
                  </draggable>
                </div>
                <div  class="col-sm-5">
                  <Swiper id="Swiper" ref='swiper' :data="langItem.imageCaption"></Swiper>
                </div>
              </div>
              <!--div class="form-group">
                <label class="col-sm-2 control-label">
                  template 
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <select class="form-control"  :name="'templateId'+langLabel(langItem.langCode)" v-validate="'required'" v-model="articleDetail.templateId">
                      <option  value="1">down</option>
                      <option  value="2">up</option>
                    </select>
                  </div>
                  <label class="error">{{ errors.first('templateId'+langLabel(langItem.langCode)) }}</label>
                </div>
              </div-->
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.Tags") }}
                </label>
                <div class="input-group col-sm-10" style="padding: 0 15px;">
                    <input type="text" 
                           v-bind:placeholder='$t("message.tagsTip")'  
                           v-model="synonyms" 
                           class="input input-sm form-control" 
                           :maxlength="langItem.langCode=='en_US'?100:50"
                    />
                    <span class="input-group-btn">
                            <div  class="btn btn-sm btn-white" @click="addTagEvent(langItem)"> <i class="fa fa-plus"></i> {{$t("message.Add tag") }}
                            </div>
                    </span>
                </div>  
              </div>
              <div class="form-group">
                  <label class="col-sm-2 control-label" ></label>
                  <div class="col-sm-10">
                      <ul class="tag-list" style="padding: 0">
                          <li v-for = "(data,_index) in langItem.tags" >
                              <a ><span style="padding-right: 15px;">{{data}}</span> <i class="fa fa-trash-o" @click="deleteTagEvent(_index,langItem)"></i></a>
                              
                          </li>
                      </ul>   
                  </div>       
              </div> 
              <div class="form-group">
                <label class="col-sm-2 control-label">
                 {{$t("message.Recommended articles") }} 
                </label>
                <div class="col-sm-10 jstreeHeight">
                  <v-jstree :data="articleList" show-checkbox multiple allow-batch whole-row @item-click="itemClick"></v-jstree>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <div class="btn btn-primary" v-if="articleDetail.status!=10" @click="submit()">{{$t("message.Save") }}</div>
                    <div class="btn btn-white" @click="showWarning()">{{$t("message.Cancel") }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import fileupload from "../components/common/fileupload";
import eventBus from "../eventbus";
import config from "../config";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
const upload = require('../upload')
import Swiper from '../components/common/Swiper.vue'
import draggable from 'vuedraggable'

import VJstree from 'vue-jstree'

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      categoryId:"",
      articleDetail:{
        categoryId:'',
        subCategoryIds:"",
        templateId:1,
        magazineId:'',
        recommendedArticles:[]
      },
      categoryList:[],
      subCategoryList:[],
      editor: ClassicEditor,
      editorConfig: {
         removePlugins: [ 'Table' ],
         extraPlugins: [ upload.MyCustomUploadAdapterPlugin ]
          // The configuration of the editor.
      },
      editorReady:false,
      addImage:"",
      synonyms:"",
      issueList:[],
      articleList:[],
    };
  },
  components: {
    Swiper,
    VJstree,
    draggable,
    "file-upload": fileupload
  },
  created() {
    let langMap = [];
    this.langKey.forEach(element => {
      langMap.push({ 
        langCode: element,
        tags:[],
        imageCaption:[],
      });
    });
    let imageCaption = []
    // this.articleDetail.langMap = langMap;
    this.$set(this.articleDetail,'langMap',langMap)
    this.$set(this.articleDetail,'imageCaption',imageCaption)
    this.init();
  },
  mounted() {
    setTimeout(function(){
      $(".tab" + 1)
        .parent()
        .find("a")
        .click();

      $(".tab" + 0)
        .parent()
        .find("a")
        .click();
    })
  },
  methods: {
    async init() {
      let id = this.$route.query.id;
      if (id) {
        let obj = this.getAuthObj;
        obj.articleId = id;
        let data = await this.$store.dispatch("getArticleDetail", this.setFormData(obj));
        data.data.result.subCategoryIds = [];
        for(var i=0;i<data.data.result.subCategoryList.length;i++){
          data.data.result.subCategoryIds.push(data.data.result.subCategoryList[i].id);
        }
        data.data.result.subCategoryIds = data.data.result.subCategoryIds.join(',')
        for(var i=0;i<data.data.result.langMap.length;i++){
          data.data.result.langMap[i].imageCaption = JSON.parse(data.data.result.langMap[i].imageCaption);
          // data.data.result.langMap[i].imageCaption = [];
          if(data.data.result.langMap[i].tags){
            data.data.result.langMap[i].tags = data.data.result.langMap[i].tags.split(",");
          }else{
            data.data.result.langMap[i].tags = []
          }
        }
        if(data.data.result.recommendedArticles){
          data.data.result.recommendedArticles = data.data.result.recommendedArticles.split(",");
        }else{
          data.data.result.recommendedArticles = [];
        }
        var langMap = [];
        this.langKey.forEach(element => {
          for(var i=0;i<data.data.result.langMap.length;i++){
            if(data.data.result.langMap[i].langCode==element){
              langMap.push(data.data.result.langMap[i])
            }
          }
        });
        data.data.result.langMap = langMap;
        this.$set(this, "articleDetail", data.data.result);
      } else {
      }
      this.getSubCategoryList();
      // this.getCategoryList();
      this.issueListEvent();
      // this.getArticleList();
    },
    async getSubCategoryList() {
      let objdata = this.getAuthObj;
      objdata.sortField = 'id';
      objdata.sortType = "ASC";
      objdata.startRow = 0;
      objdata.maxRows = 10000;
      let data = await this.$store.dispatch("getSubCategoryList", this.setFormData(objdata));
      let list = null;
      for(var i=0;i<data.data.result.length;i++){
        for(var j=0;j<data.data.result[i].langMap.length;j++){
          if(data.data.result[i].langMap[j].langCode=="en_US"){
            data.data.result[i]['name'+'en_US'] = data.data.result[i].langMap[j].name;
          }
          if(data.data.result[i].langMap[j].langCode=="zh_HK"){
            data.data.result[i]['name'+'zh_HK'] = data.data.result[i].langMap[j].name;
          }
          if(data.data.result[i].langMap[j].langCode=="zh_CN"){
            data.data.result[i]['name'+'zh_CN'] = data.data.result[i].langMap[j].name;
          }
        }
      }
      this.subCategoryList = data.data.result;
    },
    async issueListEvent(){
      let objdata = this.getAuthObj;
      objdata.sortField = 'id';
      objdata.sortType = "ASC";
      objdata.startRow = 0;
      objdata.maxRows = 10000;


      let data = await this.$store.dispatch("getMagazineList", this.setFormData(objdata));

      for(var i=0;i<data.data.resultList.length;i++){
        for(var j=0;j<data.data.resultList[i].langMap.length;j++){
          if(data.data.resultList[i].langMap[j].langCode=="en_US"){
            data.data.resultList[i]['title'+'en_US'] = data.data.resultList[i].langMap[j].title;
          }
          if(data.data.resultList[i].langMap[j].langCode=="zh_HK"){
            data.data.resultList[i]['title'+'zh_HK'] = data.data.resultList[i].langMap[j].title;
          }
          if(data.data.resultList[i].langMap[j].langCode=="zh_CN"){
            data.data.resultList[i]['title'+'zh_CN'] = data.data.resultList[i].langMap[j].title;
          }
        }
      }
      this.$set(this, "issueList", data.data.resultList);
    },
    async getArticleList(){
        let obj = this.getAuthObj;
        obj.sortField = 'id';
        obj.sortType = "ASC";
        obj.startRow = 0;
        obj.maxRows = 10000;
        obj.states = 10;
        let data = await this.$store.dispatch("getArticleList", this.setFormData(obj));
        let Article = data.data.resultList;
        for(var i=0;i<Article.length;i++){
          Article[i].selected = false;
          for(var k=0;k<this.articleDetail.recommendedArticles.length;k++){
            if(Article[i].id==this.articleDetail.recommendedArticles[k]){
              Article[i].selected = true;
            }
          }
          for(var j=0;j<Article[i].langMap.length;j++){
            if(Article[i].langMap[j].langCode=="en_US"){
              Article[i].name = Article[i].langMap[j].title;
            }
          }
        }
        let articleList = [];
        for(var i=0;i<Article.length;i++){
          articleList.push({
            "id": Article[i].id,
            "text": Article[i].name,
            "selected":Article[i].selected,
            children: []
          })
        }
        this.$set(this, "articleList", articleList);
    },
    async getCategoryList(){
        let obj = this.getAuthObj;
        let data = await this.$store.dispatch("getCategoryList", this.setFormData(obj));
        
        for(var i=0;i<data.data.result.length;i++){
          for(var j=0;j<data.data.result[i].langMap.length;j++){
            if(data.data.result[i].langMap[j].langCode=="en_US"){
              data.data.result[i]['name'+'en_US'] = data.data.result[i].langMap[j].name;
            }
            if(data.data.result[i].langMap[j].langCode=="zh_HK"){
              data.data.result[i]['name'+'zh_HK'] = data.data.result[i].langMap[j].name;
            }
            if(data.data.result[i].langMap[j].langCode=="zh_CN"){
              data.data.result[i]['name'+'zh_CN'] = data.data.result[i].langMap[j].name;
            }
          }
        }
        this.$set(this, "categoryList", data.data.result);
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        that.$router.go(-1);
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [{
              name:this.$i18n.t("message.Confirm"),
              callBack:function(){
                that.callDelete();
              }
            }, {
              name:this.$i18n.t("message.Cancel"),
              callBack:function(){
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });                
              }
            }]
        });
      }
    },
    async submit() {
      try {
        let vresult = await this.$validator.validate();
        if (!vresult) {
          this.fillInRequired();
          return;
        }
        let obj = this.getAuthObj;
        for(var key in this.articleDetail){
          var detail = JSON.stringify(this.articleDetail[key])
          obj[key] = JSON.parse(detail);
        }
        for(var i=0;i<obj.langMap.length;i++){
          obj.langMap[i].imageCaption = JSON.stringify(obj.langMap[i].imageCaption);
          obj.langMap[i].tags = obj.langMap[i].tags.join(',');
        }
        obj.langData = JSON.stringify(obj.langMap);

        let recommendedArticles = [];
        for(var i=0;i<this.articleList.length;i++){
          if(this.articleList[i].selected){
            recommendedArticles.push(this.articleList[i].id);
          }
        }
        if(recommendedArticles.length>5){
          this.$toastr.w(this.$i18n.t("message.Maximum 5"),"Warning");
          return;
        }
        obj.recommendedArticles = recommendedArticles.join(',');
        if(this.$route.query.id){
           var  data = await this.$store.dispatch("updateArticle", this.setFormData(obj));
        }else{
           var  data = await this.$store.dispatch("createArticle", this.setFormData(obj));
        }
        
        if (data.data.errorCode === 0) {
          this.$router.go(-1);
        }
      } catch (err) {
        console.error(err);
      }
    },
    Delete() {
      this.showWarning(1);
    },
    async callDelete() {
      try {
        let obj = this.getAuthObj;
        obj.articleIds = this.$route.query.id;
        let data = await this.$store.dispatch("deleteArticle", this.setFormData(obj));
        if (data.data.errorCode === 0) {
          this.$router.go(-1);
        }
      } catch (err) {
        console.error(err);
      }
    },
    langLabel(lang) {
      if (lang === "en_US") {
        return "EN";
      } else if (lang === "zh_HK") {
        return "T. Chi.";
      } else if (lang === "zh_CN") {
        return "S. Chi.";
      }
    },
    changeTab: function(id) {
      $(".tab" + id)
        .parent()
        .find("a")
        .click();
    },
    showTab: function($event, tabId) {
      $event.preventDefault();
      switch (tabId) {
        case "1":
          $scope.tab1 = true;
          $($event.target).tab("show");
          break;
        case "2":
          $scope.tab2 = true;
          $($event.target).tab("show");
          break;
      }
    },
    addSlideShowImage:function(data,item){
      for(var i=0;i<this.articleDetail.langMap.length;i++){
        if(this.articleDetail.langMap[i].langCode==item.langCode){
          this.articleDetail.langMap[i].imageCaption.push({
            img:data.fullName,
            caption:""
          });
          this.$set(this.articleDetail.langMap[i], "imageCaption", this.articleDetail.langMap[i].imageCaption);
          this.$refs.swiper[i].reflash(this.articleDetail.langMap[i].imageCaption);
        }
      }
      this.addImage = "";
    },
    addTagEvent:function(langItem){
      if(!this.synonyms) return;
      var synonyms = this.synonyms.split(";");
      if((langItem.tags.length+synonyms.length)>5){
          this.$toastr.w(this.$i18n.t("message.Maximum 5"),"Warning");
          return;
      }
      for(var i=0;i<synonyms.length;i++){
          langItem.tags.push(synonyms[i]);
      }
      this.synonyms = "";
    },
    deleteTagEvent:function(index,langItem){
      this.$delete(langItem.tags,index);
      return;
      for(var i=0;i<this.articleDetail.langMap.length;i++){
        if(this.articleDetail.langMap[i].langCode==langItem.langCode){
          this.articleDetail.langMap[i].tags.splice(index,1);
          this.$set(this.articleDetail.langMap[i], "tags", this.articleDetail.langMap[i].tags);
        }
      }
    },
    itemClick:function(){

    },
    deleteCaption:function(index,data){
      data.splice(index,1);
    }
  }
};
</script>
